import { useMemo } from 'react';
import useChatContacts from './useChatContacts';
import useSelectedContactId from './useSelectedContactId';

const useSelectedMainContact = () => {
  const selectedContactId = useSelectedContactId();
  const { contacts } = useChatContacts();
  return useMemo(() => {
    const contact = contacts.find(({ id }) => id === selectedContactId);
    if (contact && contact.mainContactId) {
      return contacts.find(({ id }) => id === contact.mainContactId);
    }
    return contact;
  }, [selectedContactId, contacts]);
};

export default useSelectedMainContact;
